import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { label: 'Accueil', id: 'hero' },
    { label: 'Notre Histoire', id: 'histoire' },
    { label: 'Savoir-faire', id: 'services' },
    { label: 'Pourquoi nous', id: 'pourquoi' },
    { label: 'Partenaires', id: 'partenaires' },
    { label: 'Contact', id: 'contact' }
  ];

  // Company name with colors
  const CompanyLogo = ({ scrolled }) => (
    <button
      onClick={() => scrollToSection('hero')}
      className="font-serif text-lg md:text-xl font-semibold tracking-wide"
    >
      <span className={scrolled ? 'text-red-600' : 'text-red-400'}>DÉCORATION </span>
      <span className={scrolled ? 'text-amber-500' : 'text-amber-400'}>DE SOUSA </span>
      <span className={scrolled ? 'text-[#0a1628]' : 'text-blue-400'}>FRÈRES</span>
    </button>
  );

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <CompanyLogo scrolled={isScrolled} />

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className={`text-sm font-medium tracking-wide transition-all duration-300 hover:opacity-70 ${
                isScrolled ? 'text-stone-700' : 'text-white/90'
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={`lg:hidden p-2 transition-colors ${
            isScrolled ? 'text-stone-800' : 'text-white'
          }`}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden absolute top-full left-0 right-0 bg-white shadow-xl transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="flex flex-col py-4">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className="px-6 py-3 text-left text-stone-700 hover:bg-stone-50 transition-colors"
            >
              {link.label}
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
